import Audio from '~/Audio';
import Colors from '~/constants/Colors';
import { logError } from '~/logger';
import text from '~/text';
import { validateEquipMove } from 'dt-common/validators/gameItemMove';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import mutationEquipItem from '~/graphql/game-items/mutationEquipItem';
import messages, { HeroBuildStoreMessage } from '../messages';
import { HeroBuilds } from 'dt-common/generated/prisma';
import { ItemLocationInput } from 'dt-common/generated/graphql-types';

export default async function equipItem(
  {
    playerId,
    hero_builds,
    setHeroBuilds,
    emit,
  }: {
    playerId: string | null;
    hero_builds: HeroBuilds;
    setHeroBuilds: (builds: HeroBuilds) => void;
    emit: (message: HeroBuildStoreMessage) => void;
  },
  action: {
    game_item: { uid: string; slot?: string };
    from: ItemLocationInput;
    to: ItemLocationInput;
  }
) {
  const check = validateEquipMove(action.game_item.slot, action.to.slot);
  if (!check.ok) {
    window.$addMessageLogMessage(text(check.errorKey), Colors.RED);
    return;
  }

  try {
    const result = await mutationEquipItem({
      playerId: playerId!,
      itemId: action.game_item.uid,
      from: action.from,
      to: action.to,
    });

    setHeroBuilds({ ...hero_builds, [result.heroHandle]: result.target_hero_builds });
    emit(messages.ITEM_EQUIPPED);
    Audio.play('equipment_storage');
  } catch (err) {
    const errorKey = err instanceof GraphQlRequestError ? err.errors?.[0]?.message : undefined;
    if (typeof errorKey === 'string' && text(errorKey)) {
      window.$addMessageLogMessage(text(errorKey), Colors.RED);
    } else {
      window.$addMessageLogMessage(text('server_error'), Colors.RED);
      logError(err, {
        module: 'HeroBuildStore',
        func: 'equipItem',
        playerId,
        action: JSON.stringify(action),
      });
    }
  }
}
